const about_long_des = {
  text: 
  "Η Παναγιωτάκη Σοφία είναι χειρουργός οδοντίατρος για ενήλικες και παιδιά και διατηρεί ιδιωτικό ιατρείο στη Νέα Φιλαδέλφεια. Αποφοίτησε το 2017 και έπειτα εργάστηκε εθελοντικά στο οδοντιατρείο του Πολεμικού Ναυτικού για 2 έτη ως γενική οδοντίατρος, ενώ παράλληλα συνεργάστηκε για 4 έτη με ιδιωτική κλινική, όπου αναλάμβανε περιστατικά προσθετικής και αισθητικής οδοντιατρικής.",
};

export default about_long_des;
